import { memo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export interface FluxmedOptionCardProps {
  showFluxmedCardHighlight: boolean;
  shouldDimFluxmedCard: boolean;
  isUsingDefaultOption: boolean;
  isSavingOption: boolean;
  onSelectFluxmedClick: () => void;
}

const FluxmedOptionCard = memo((props: FluxmedOptionCardProps) => {
  const {
    showFluxmedCardHighlight,
    shouldDimFluxmedCard,
    isUsingDefaultOption,
    isSavingOption,
    onSelectFluxmedClick,
  } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        p: 2.5,
        borderRadius: 2,
        border: "2px solid",
        borderColor: showFluxmedCardHighlight
          ? alpha(theme.palette.success.main, 0.55)
          : "divider",
        bgcolor: showFluxmedCardHighlight
          ? alpha(theme.palette.success.main, 0.06)
          : "background.default",
        boxShadow: showFluxmedCardHighlight
          ? `0 0 0 3px ${alpha(theme.palette.success.main, 0.15)}, 0 6px 20px ${alpha(theme.palette.success.main, 0.12)}`
          : "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 2,
        opacity: shouldDimFluxmedCard ? 0.55 : 1,
        minHeight: { md: 360 },
        transition:
          "box-shadow 0.25s ease, border-color 0.25s ease, background 0.25s ease, opacity 0.2s ease",
      }}
    >
      <Stack spacing={1}>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          Utilizar número padrão da Fluxmed
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Caso não queira configurar a conta de envio agora, você pode
          continuar usando o número padrão da Fluxmed.
        </Typography>
        <Chip
          icon={<WhatsAppIcon />}
          label="Envio em modo simulado"
          variant="outlined"
        />
      </Stack>
      <Stack spacing={1}>
        <Typography variant="caption" color="text.secondary">
          Ideal para conhecer o fluxo antes da integração completa com a
          Meta.
        </Typography>
        <Button
          variant="outlined"
          type="button"
          onClick={onSelectFluxmedClick}
          disabled={isUsingDefaultOption || isSavingOption}
          fullWidth
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          {isUsingDefaultOption
            ? "Opção Fluxmed selecionada"
            : "Selecionar opção Fluxmed"}
        </Button>
      </Stack>
    </Box>
  );
});

FluxmedOptionCard.displayName = "FluxmedOptionCard";

export default FluxmedOptionCard;
